import { render, staticRenderFns } from "./VersionContent.vue?vue&type=template&id=531a7231&scoped=true"
import script from "./VersionContent.vue?vue&type=script&lang=js"
export * from "./VersionContent.vue?vue&type=script&lang=js"
import style0 from "./VersionContent.vue?vue&type=style&index=0&id=531a7231&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531a7231",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531a7231')) {
      api.createRecord('531a7231', component.options)
    } else {
      api.reload('531a7231', component.options)
    }
    module.hot.accept("./VersionContent.vue?vue&type=template&id=531a7231&scoped=true", function () {
      api.rerender('531a7231', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VersionContent.vue"
export default component.exports